import bullet from './bullet.svg';
import ordered from './ordered.svg';

export default { bullet, ordered };
